// Angular imports
import { Component, HostListener } from '@angular/core';

// Service imports
import { ScreenService } from '../_services/shared-services/screen.service';

@Component({
  selector: `app-base-component`,
  template: ``,
  standalone: false
})
export abstract class BaseComponent {
  innerHeight: number;
  isXtraSmall = false;
  isSmall = false;
  isMedium = false;

  constructor(protected screenService: ScreenService) {
    this.isXtraSmall = this.screenService.isXSmallScreen();
    this.isSmall = this.screenService.isSmallScreen();
    //this.isMedium = this.screenService.isMedium();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerHeight = window.innerHeight;
  }

  getMarginTopForXtraSmallDevice(value: number) {
    if (this.screenService.isXSmallScreen()) {
      return { 'margin-top': value + 'px' };
    }
    return {};
  }
}
